import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type {
  ListSupplierWarehouseConstraintsInput,
  ListSupplierWarehouseConstraintsResponse,
  SupplierWarehouseConstraintRow,
} from '@erp/rpc';

export type {
  SupplierWarehouseConstraintRow,
  ListSupplierWarehouseConstraintsResponse,
};

export function useSupplierWarehouseConstraints(
  input: ListSupplierWarehouseConstraintsInput,
  enabled = true,
) {
  return useQuery<ListSupplierWarehouseConstraintsResponse>({
    ...orpc.procurement.supplierWarehouseConstraints.list.queryOptions({
      input,
    }),
    enabled: enabled && !!input.supplierId,
  });
}
